import React from 'react';
import { ReactComponent as DailyRepetitionIcon } from '../../utils/icons/RepetitionDaily.svg';
import { ReactComponent as WeeklyRepetitionIcon } from '../../utils/icons/RepetitionWeekly.svg';
import { ReactComponent as MonthlyRepetitionIcon } from '../../utils/icons/RepetitionMonthly.svg';
import { ReactComponent as YearlyRepetitionIcon } from '../../utils/icons/RepetitionYearly.svg';
import { OwcIcon } from '@one/react';
import { react18WorkaroundProps } from "../constants/constants";

const renderIcon = (
  IconComponent: React.ComponentType,
  style?: React.CSSProperties,
) => (
  <OwcIcon
    style={{ display: 'flex', ...style }}
    {...react18WorkaroundProps}
  >
    <IconComponent />
  </OwcIcon>
);

export const getRepetitionIcon = (rruleText: string, style?: React.CSSProperties) => {
  const frequency = rruleText.split(' ')[0]?.toLocaleLowerCase();

  switch (frequency) {
    case 'daily':
      return renderIcon(DailyRepetitionIcon, style);
    case 'weekly':
      return renderIcon(WeeklyRepetitionIcon, style);
    case 'monthly':
      return renderIcon(MonthlyRepetitionIcon, style);
    case 'yearly':
      return renderIcon(YearlyRepetitionIcon, style);
    default:
      return null;
  };
};
